import React from 'react';
import { inject, observer } from 'mobx-react';
import MeetingModel from '@/models/meeting';
import { useIntl } from 'umi';
import lottie from 'lottie-web';
import Style from './index.less';

interface LeaveProps {
  meeting: MeetingModel;
}

interface ParamsStruct {
  meetingId: string;
}

const Leave: React.FC<LeaveProps> = inject(({ store }) => {
  return {
    meeting: store.meeting,
  };
})(
  observer(() => {
    const { formatMessage } = useIntl();
    const ref = React.useRef<HTMLDivElement>(null);
    React.useEffect(() => {
      if (!window.location.search.match('type=improve')) {
        lottie.loadAnimation({
          container: ref.current!, // the dom element that will contain the animation
          renderer: 'svg',
          loop: true,
          autoplay: false,
          path: 'https://popo.fp.ps.netease.com/file/603eeca85e60276669121a94wJEHLWpq03.json', // the path to the animation json
        });
        lottie.play();
      }
    }, []);
    return (
      <div className={Style['popo-meeting-leave-page']}>
        <div className={Style.animation} ref={ref} />
        <div className={Style.content}>
          <img className={Style.image} src={require('../../assets/meeting-ending.png')} alt="" />
          <h1 className={Style.title}>{formatMessage({ id: 'THANKS' })}</h1>
        </div>
      </div>
    );
  })
);

export default Leave;
